/**
 * Redirect user to newly opened tab with a specific URL.
 *
 * @param path - target path to open in the new browser tab
 */
export function openNewFocusedTab(path: string): void {
  window.open(path, '_blank')?.focus();
}

/**
 * Redirect to vimeo root path.
 */
export function redirectToHome(): void {
  return redirectTo('/');
}

/**
 * Redirects the user to the specified path.
 *
 *  @param path - target path to redirect to
 */
export function redirectTo(path: string): void {
  window.location.href = path;
}
